export const ProjectConfig = {
    footer: false,
    searchInNavbar: false,
    supportLanguageSwitching: true,
    supportThemeSwitching: false
};